export default __webpack_public_path__ + "static/media/020_start.ca5f24d2.mp4";